import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, COLLECTION, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import ConsignmentRuleService from '@/plugins/sdk/resources/Account/ConsignmentRule/Service'

export default class extends Resource {
  static name = 'account_consignment_rule'

  static get fields () {
    return {
      id: new UUID(),
      account: new ITEM(Account),
      name: new STRING(),
      allow_children: new BOOLEAN(),
      global: new BOOLEAN(),
      expression: new STRING(),
      services: new COLLECTION(ConsignmentRuleService),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
